import React, { useContext } from "react";
import { Tabs, Tab } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";

import OnlinePredictionOutlinedIcon from "@mui/icons-material/OnlinePredictionOutlined";
import AbcOutlinedIcon from "@mui/icons-material/AbcOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

import { LanguageContext } from "./LanguageContext";

const TABS = [
    {
        key: "informacije",
        label: "Forecast",
        translationKey: "adminExcelProInfoPageForecast",
        icon: <OnlinePredictionOutlinedIcon fontSize="small" />,
        path: (storeId, excelId) =>
            `/prodavnica/${storeId}/informacije/${excelId}`,
    },
    {
        key: "abc-ved",
        label: "ABC-VED",
        translationKey: "adminExcelProInfoPageABCVed",
        icon: <AbcOutlinedIcon fontSize="small" />,
        path: (storeId, excelId) =>
            `/prodavnica/${storeId}/informacije/${excelId}/abc-ved`,
    },
    {
        key: "analiza",
        label: "Analiza",
        translationKey: "adminExcelProInfoPageAnalysis",
        icon: <LeaderboardOutlinedIcon fontSize="small" />,
        path: (storeId, excelId) =>
            `/prodavnica/${storeId}/informacije/${excelId}/analiza`,
    },
    {
        key: "nabavka",
        label: "Nabavka",
        translationKey: "adminExcelProInfoPageAcquisition",
        icon: <Inventory2OutlinedIcon fontSize="small" />,
        path: (storeId, excelId) =>
            `/prodavnica/${storeId}/informacije/${excelId}/nabavka`,
    },
];

const CalculationTabs = ({ active }) => {
    const { storeId, excelId } = useParams();
    const { translations } = useContext(LanguageContext) || {};

    const activeIdx = Math.max(
        0,
        TABS.findIndex((t) => t.key === active)
    );

    return (
        <Tabs
            value={activeIdx}
            variant="scrollable"
            scrollButtons="auto"
            sx={(theme) => ({
                mb: 3,
                borderBottom: `1px solid ${theme.palette.divider}`,
                "& .MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 500,
                    minHeight: 48,
                    minWidth: "auto",
                    px: 2,
                },
            })}
        >
            {TABS.map((tab) => (
                <Tab
                    key={tab.key}
                    component={RouterLink}
                    to={tab.path(storeId, excelId)}
                    icon={tab.icon}
                    iconPosition="start"
                    label={translations?.[tab.translationKey] || tab.label}
                />
            ))}
        </Tabs>
    );
};

export default CalculationTabs;